var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-referral-footer",attrs:{"role":"footer"}},[_c('div',{staticClass:"plugin-referral-footer__headline"},[_c('plugin-referral-footer-headline')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }